import Hstack from "@/components/ui/hstack";
import type { NavBarItem } from "@/shared/types/nav";
import { Text } from "@radix-ui/themes";
import { Link } from "@tanstack/react-router";

type Props = {
  navKey: NavBarItem[];
};
export default function NavBar({ navKey }: Props) {
  // const { pathname } = useLocation();
  // const name = pathname.split("/")[1];

  return (
    <Hstack gap={"8px"}>
      {navKey.map((item) => (
        <Link key={item.key} to={item.key}>
          {/* <Hstack
            gap={"6px"}
            align={"center"}
            className={` ${
              item.key === `/${name}` ? "bg-[#912018]" : "bg-transparent"
            } py-[8px] px-[12px] rounded-md cursor-pointer hover:bg-[#912018] transition-all duration-200`}
          >
            {item.key === `/${name}` && item.icon && (
              <item.icon width={"16px"} height={"16px"} />
            )}
            <Text
              className={`text-[14px] font-normal text-white leading-[20px] text-nowrap`}
            >
              {item.name}
            </Text>
          </Hstack> */}
          <Hstack
            gap={"6px"}
            align={"center"}
            className={` ${"bg-[#912018]"} py-[8px] px-[12px] rounded-md cursor-pointer hover:bg-[#912018] transition-all duration-200`}
          >
            <item.icon width={"16px"} height={"16px"} />
            <Text
              className={`text-[14px] font-normal text-white leading-[20px] text-nowrap`}
            >
              {item.name}
            </Text>
          </Hstack>
        </Link>
      ))}
    </Hstack>
  );
}
